import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Select } from '@/components/ui/select';
import { Filter, Search } from 'lucide-react';

interface NotificationFiltersProps {
  searchQuery: string;
  typeFilter: string;
  readFilter: string;
  sortOrder: string;
  onSearchChange: (value: string) => void;
  onTypeFilterChange: (value: string) => void;
  onReadFilterChange: (value: string) => void;
  onSortChange: (value: string) => void;
}

export function NotificationFilters({
  searchQuery,
  typeFilter,
  readFilter,
  sortOrder,
  onSearchChange,
  onTypeFilterChange,
  onReadFilterChange,
  onSortChange,
}: NotificationFiltersProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Filter className="h-5 w-5" />
          Filters & Sort
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="flex flex-col sm:flex-row gap-4">
          <div className="relative flex-1">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              placeholder="Search notifications..."
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              className="pl-9"
            />
          </div>
          <Select value={typeFilter} onChange={(e) => onTypeFilterChange(e.target.value)} className="w-full sm:w-[180px]">
            <option value="all">All Types</option>
            <option value="success">Success</option>
            <option value="error">Error</option>
            <option value="warning">Warning</option>
            <option value="information">Information</option>
            <option value="action">Action</option>
          </Select>
          <Select value={readFilter} onChange={(e) => onReadFilterChange(e.target.value)} className="w-full sm:w-[180px]">
            <option value="all">All</option>
            <option value="unread">Unread</option>
            <option value="read">Read</option>
          </Select>
          <Select value={sortOrder} onChange={(e) => onSortChange(e.target.value)} className="w-full sm:w-[180px]">
            <option value="-timestamp">Newest First</option>
            <option value="timestamp">Oldest First</option>
          </Select>
        </div>
      </CardContent>
    </Card>
  );
}
